import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, InputNumber, Select, message, Card, Space, List, Typography, Upload, Progress } from 'antd';
import { 
  VideoCameraOutlined,  
  FileTextOutlined,  
  PlayCircleOutlined,  
  SaveOutlined,
  DeleteOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  UploadOutlined,
  LoadingOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import axios from 'axios';

const { Option } = Select;
const { Title, Text } = Typography;

const VideoEditor = () => {
  const [files, setFiles] = useState([]); 
  const [activeRenders, setActiveRenders] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [selectedVideo, setSelectedVideo] = useState(null); 
  const [multiQueue, setMultiQueue] = useState([]); 
  const [renderMode, setRenderMode] = useState('single'); 
  
  const [exportName, setExportName] = useState('');
  const [resW, setResW] = useState(1280);
  const [resH, setResH] = useState(720);
  const [bitrate, setBitrate] = useState('2000');
  const [fps, setFps] = useState(30);
  
  const [startH, setStartH] = useState(0);
  const [startM, setStartM] = useState(0);
  const [startS, setStartS] = useState(0);
  const [duration, setDuration] = useState(10);
  const [cropW, setCropW] = useState(null);
  const [cropH, setCropH] = useState(null);
  const [cropX, setCropX] = useState(0);
  const [cropY, setCropY] = useState(0);
  const [stackCount, setStackCount] = useState(1); 

  const [processing, setProcessing] = useState(false);

  const CARD_MIN_HEIGHT = '40px'; 
  const CARD_PADDING = '10px 20px'; 

  const fetchData = async () => {
    try {
      const response = await axios.get('/api/box/media/');
      const allMedia = response.data.filter(f => f.file_type === 'video' || f.media_type === 'video');
      const ready = allMedia.filter(f => f.duration > 0);
      const inProgress = allMedia.filter(f => !f.duration || f.duration === 0);
      setFiles(ready);
      setActiveRenders(inProgress);
    } catch (error) {
      console.error('Greška pri učitavanju');
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleUpload = async (options) => {
    const { file, onSuccess, onError } = options;
    const formData = new FormData();
    const fileType = file.type.startsWith('image/') ? 'image' : 'video';
    formData.append('file', file);
    formData.append('name', file.name);
    formData.append('file_type', fileType);
    formData.append('file_size', file.size);
    setIsUploading(true);
    setUploadProgress(0);
    try {
      const response = await axios.post('/api/box/media/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        }
      });
      message.success(`Fajl ${file.name} uspešno otpremljen!`);
      setIsUploading(false);
      onSuccess(response.data);
      fetchData();
    } catch (error) {
      setIsUploading(false);
      onError(error);
      message.error('Greška pri otpremanju');
    }
  };

  const handleDrop = (video) => {
    if (renderMode === 'multi') {
      setMultiQueue([...multiQueue, { ...video, tempId: Date.now() + Math.random() }]);
    } else {
      setSelectedVideo(video);
      if(video.duration) setDuration(video.duration);
      if (video.resolution?.includes('x')) {
        const [w, h] = video.resolution.split('x');
        setResW(parseInt(w)); setResH(parseInt(h));
      }
    }
  };

  const moveInQueue = (index, direction) => {
    const newQueue = [...multiQueue];
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= newQueue.length) return;
    [newQueue[index], newQueue[targetIndex]] = [newQueue[targetIndex], newQueue[index]];
    setMultiQueue(newQueue);
  };

  const formatUrl = (input) => {
    if (!input) return null;
    let path = typeof input === 'object' ? (input.file_url || input.file_path || input.thumbnail || null) : input;
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const cleanPath = path.replace(/^\/?(media\/)?/, '');
    return `https://escreen.stand.ledscreen.rs/media/${cleanPath}`;
  };

  const handleStartProcess = async () => {
    if (!exportName) return message.error("Unesi naziv exporta");
    setProcessing(true);
    const payload = {
      export_name: exportName,
      target_bitrate: bitrate,
      fps: fps,
      media_type: 'video',
      process_mode: renderMode === 'single' ? 'single' : 'concat',
      parent_media_ids: renderMode === 'single' ? [selectedVideo?.id] : multiQueue.map(v => v.id),
      target_resolution: `${resW}x${resH}`,
      stack_count: stackCount,
      start_time: `${String(startH).padStart(2,'0')}:${String(startM).padStart(2,'0')}:${String(startS).padStart(2,'0')}`,
      duration: duration,
      crop_w: cropW, crop_h: cropH,
      crop_x: cropX, crop_y: cropY
    };

    try {
      await axios.post('/api/box/process-media/', payload);
      message.success("Render pokrenut!");
      setExportName('');
      fetchData();
    } catch (e) { message.error("Greška pri pokretanju!"); }
    finally { setProcessing(false); }
  };

  return (
    <div style={{ padding: '0px', background: '#0f172a', height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      

{/* KARTICE */}
<div style={{ padding: '0px' }}>
  <Row gutter={[16, 16]} align="stretch">
    <Col span={8}>
      <div style={{ background: '#1e293b', padding: CARD_PADDING, borderRadius: '8px', border: '1px solid #334155', borderBottom: '3px solid #3b82f6', minHeight: CARD_MIN_HEIGHT, display: 'flex', alignItems: 'center', height: '100%' }}>
        <Space size="middle">
          <FileTextOutlined style={{ color: '#3b82f6', fontSize: '24px' }} />
          <div>
            <div style={{ color: '#64748b', fontSize: '12px' }}>MEDIA LIBRARY</div>
            <div style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>{files.length} Videos</div>
          </div>
        </Space>
      </div>
    </Col>

    <Col span={8}>
      <div style={{ background: '#1e293b', padding: CARD_PADDING, borderRadius: '8px', border: '1px solid #334155', borderBottom: '3px solid #3b82f6', minHeight: CARD_MIN_HEIGHT, display: 'flex', alignItems: 'center', height: '100%' }}>
        <Upload customRequest={handleUpload} showUploadList={false} disabled={isUploading} style={{ width: '100%' }}>
          <Space size="middle" style={{ cursor: 'pointer' }}>
            <UploadOutlined style={{ color: '#3b82f6', fontSize: '24px' }} />
            <div>
              <div style={{ color: '#3b82f6', fontSize: '12px', fontWeight: 'bold' }}>UPLOAD FILE</div>
              <div style={{ color: 'white', fontSize: '14px' }}>Click to add media</div>
            </div>
          </Space>
        </Upload>
        {isUploading && (
          <div style={{ flex: 1, marginLeft: '20px' }}>
            <Progress percent={uploadProgress} size="small" strokeColor="#3b82f6" trailColor="#334155" format={(p) => <span style={{ color: 'white', fontSize: '10px' }}>{p}%</span>} />
          </div>
        )}
      </div>
    </Col>

    <Col span={8}>
  <div style={{ background: '#1e293b', padding: CARD_PADDING, borderRadius: '8px', border: '1px solid #334155', borderBottom: '3px solid #3b82f6', minHeight: CARD_MIN_HEIGHT, display: 'flex', alignItems: 'center', height: '100%' }}>
    <Space size="middle">
      {
        activeRenders.length > 0 ? (
          <LoadingOutlined style={{ color: '#3b82f6', fontSize: '24px' }} />
        ) : (
          <CheckCircleOutlined style={{ color: '#22c55e', fontSize: '24px' }} />
        )
      }
      <div>
        <div style={{ color: '#64748b', fontSize: '12px' }}>ACTIVE RENDERS</div>
        <div style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>{activeRenders.length} render in progress</div>
      </div>
    </Space>
  </div>
</Col>
  </Row>
</div>

      {/* GLAVNI SADRŽAJ - DODATA MARGINA TOP (30px) */}
      <div style={{ flex: 1, margin: '30px 0px 24px 0px', background: '#1e293b', border: '1px solid #334155', borderRadius: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        
        <div style={{ padding: '15px 20px', borderBottom: '1px solid #334155' }}>
          <Title level={4} style={{ color: '#3b82f6', margin: 0, textTransform: 'uppercase', letterSpacing: '1px', fontSize: '18px' }}>
            <VideoCameraOutlined style={{ marginRight: '8px' }} /> Video Engine Pro
          </Title>
        </div>

        <div className="engine-main-layout" style={{ flex: 1, display: 'flex', gap: '10px', padding: '15px', overflow: 'hidden', alignItems: 'flex-start' }}>
          
          <div className="engine-col source-panel" style={{ flex: '0 0 25%', display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <div className="section-label">SOURCE MEDIA</div>
            <div className="media-list-container" style={{ overflowY: 'auto', flex: 1 }}>
              {files.map((item, idx) => {
                const thumbUrl = formatUrl(item.thumbnail);
                return (
                  <div key={`${item.id}-${idx}`} className="media-list-item" onClick={() => handleDrop(item)}>
                    <div className="item-thumb">
                      {thumbUrl ? (
                        <img src={thumbUrl} alt="" onError={(e) => { e.target.style.display='none'; e.target.parentNode.innerHTML='<i class="anticon anticon-video-camera" style="color:#3b82f6"></i>'; }} />
                      ) : (
                        <VideoCameraOutlined style={{ color: '#3b82f6' }} />
                      )}
                    </div>
                    <div className="item-info">
                      <div className="item-name-white">{item.name}</div>
                      <div className="item-meta-white">{item.resolution} | {item.duration}s</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="engine-col commands-panel" style={{ flex: '0 0 35%', display: 'flex', flexDirection: 'column', gap: '10px', overflowY: 'auto', height: '100%' }}>
            <div className="section-label">CONFIGURATION</div>
            
            <Card title="PROCESSING MODE" size="small" className="control-card">
              <Select value={renderMode} onChange={setRenderMode} style={{ width: '100%' }} className="dark-select">
                <Option value="single">SINGLE FILE (STACK)</Option>
                <Option value="multi">MULTI FILE (CONCAT)</Option>
              </Select>
            </Card>

            <Card title="SINGLE STACK (H-STACK)" size="small" className="control-card">
              <InputNumber min={1} max={10} value={stackCount} onChange={setStackCount} className="dark-input-num" style={{width: '100%'}} controls={false} />
            </Card>

            {renderMode === 'single' && (
              <>
                <Card title="CROP SETTINGS" size="small" className="control-card">
                  <Space>
                    <InputNumber placeholder="W" value={cropW} onChange={setCropW} className="dark-input-num-small" controls={false} />
                    <InputNumber placeholder="H" value={cropH} onChange={setCropH} className="dark-input-num-small" controls={false} />
                    <InputNumber placeholder="X" value={cropX} onChange={setCropX} className="dark-input-num-small" controls={false} />
                    <InputNumber placeholder="Y" value={cropY} onChange={setCropY} className="dark-input-num-small" controls={false} />
                  </Space>
                </Card>
                <Card title="TIMING" size="small" className="control-card">
                  <Space>
                    <InputNumber min={0} value={startH} onChange={setStartH} placeholder="H" className="dark-input-num-small" controls={false} />
                    <InputNumber min={0} value={startM} onChange={setStartM} placeholder="M" className="dark-input-num-small" controls={false} />
                    <InputNumber min={0} value={startS} onChange={setStartS} placeholder="S" className="dark-input-num-small" controls={false} />
                    <InputNumber min={1} value={duration} onChange={setDuration} placeholder="DUR" className="dark-input-num-small" controls={false} />
                  </Space>
                </Card>
              </>
            )}

            <Card title="OUTPUT SETTINGS" size="small" className="control-card">
              <Input placeholder="Export Name" value={exportName} onChange={e => setExportName(e.target.value)} className="dark-input" style={{marginBottom: '10px'}} />
              <Space style={{ marginBottom: '10px', width: '100%' }}>
                <InputNumber value={resW} onChange={setResW} className="dark-input-num" placeholder="W" controls={false} />
                <InputNumber value={resH} onChange={setResH} className="dark-input-num" placeholder="H" controls={false} />
                <Select value={bitrate} onChange={setBitrate} className="dark-select" style={{width: '90px'}}>
                  <Option value="2000">2Mbps</Option>
                  <Option value="4000">4Mbps</Option>
                </Select>
              </Space>
              <Space style={{ width: '100%' }}>
                <span style={{ color: 'white', fontSize: '12px' }}>FPS:</span>
                <Select value={fps} onChange={setFps} className="dark-select" style={{ width: '100%' }}>
                  <Option value="24">24 fps</Option>
                  <Option value="25">25 fps</Option>
                  <Option value="30">30 fps</Option>
                  <Option value="48">48 fps</Option>
                  <Option value="50">50 fps</Option>
                  <Option value="60">60 fps</Option>
                </Select>
              </Space>
            </Card>
          </div>

          <div className="engine-col right-panel" style={{ flex: '0 0 40%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div className="section-label">PREVIEW</div>
            <div className="preview-top-box" style={{ height: '300px', flex: '0 0 auto', display: 'flex', flexDirection: 'column', background: '#161e2e', border: '1px solid #334155', borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                  {renderMode === 'single' ? (
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000' }}>
                      {selectedVideo && formatUrl(selectedVideo) ? (
                        <video key={selectedVideo.id} controls autoPlay src={formatUrl(selectedVideo)} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                      ) : (
                        <PlayCircleOutlined style={{ fontSize: '48px', color: '#475569' }} />
                      )}
                    </div>
                  ) : (
                    <div style={{ flex: 1, overflowY: 'auto', padding: '10px' }}>
                      <List
                        dataSource={multiQueue}
                        renderItem={(item, idx) => (
                          <div className="queue-item">
                            <Text style={{ color: 'white', fontSize: '12px' }}>{idx + 1}. {item.name}</Text>
                            <Space>
                              <ArrowUpOutlined className="q-btn" onClick={() => moveInQueue(idx, -1)} />
                              <ArrowDownOutlined className="q-btn" onClick={() => moveInQueue(idx, 1)} />
                              <DeleteOutlined className="q-btn-del" onClick={() => setMultiQueue(multiQueue.filter(q => q.tempId !== item.tempId))} />
                            </Space>
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
            </div>
            <Button type="primary" icon={<SaveOutlined />} onClick={handleStartProcess} loading={processing} className="btn-render-big" block>
              START PROCESS
            </Button>
          </div>
        </div>
      </div>

      <style>{`
        .media-list-item { display: flex; gap: 10px; padding: 8px; background: #0f172a; border: 1px solid #334155; border-radius: 6px; margin-bottom: 6px; cursor: pointer; }
        .item-thumb { width: 60px; height: 40px; background: #000; border-radius: 4px; overflow: hidden; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
        .item-thumb img { width: 100%; height: 100%; object-fit: cover; }
        .item-name-white { color: #ffffff !important; font-size: 11px; font-weight: bold; }
        .item-meta-white { color: #ffffff !important; font-size: 10px; opacity: 0.8; }
        .queue-item { background: #0f172a; border: 1px solid #475569; margin-bottom: 5px; padding: 8px; border-radius: 4px; display: flex; justify-content: space-between; align-items: center; }
        .q-btn { color: #3b82f6; cursor: pointer; }
        .q-btn-del { color: #ef4444; cursor: pointer; }
        .control-card { background: #161e2e !important; border: 1px solid #334155 !important; }
        .control-card .ant-card-head-title { color: #ffffff !important; font-size: 10px !important; text-transform: uppercase; font-weight: bold; }
        .dark-input, .dark-input-num, .dark-input-num-small { background: #0f172a !important; border: 1px solid #334155 !important; color: white !important; }
        .dark-input-num-small { width: 60px !important; }
        .dark-select .ant-select-selector { background: #0f172a !important; border: 1px solid #334155 !important; color: white !important; }
        .btn-render-big { background: #3b82f6 !important; height: 50px !important; font-weight: bold !important; border: none; }
        .section-label { font-size: 11px; color: #ffffff !important; font-weight: bold; text-transform: uppercase; }
        .ant-input-number-input, .ant-input { color: white !important; }
      `}</style>
    </div>
  );
};

export default VideoEditor;